import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

export const fetchScreens = createAsyncThunk(
    'screens/fetchScreens',
    async () => {

        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/pages`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
);